import { useAtom } from "jotai";
import { currentStep } from "../../../../../app/store";
import { useState } from "react";

export default function useNewC6BankModal() {
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [step, setStep] = useAtom(currentStep);

  const steps = {
    personalInfo: step === 0,
    address: step === 1,
    bankInfo: step === 2,
    review: step === 3,
    sentProposal: step === 4,
  };

  const title = [
    "Informações do cliente",
    "Endereço do cliente",
    "Dados bancários do cliente",
    "Dados da proposta",
  ];

  return {
    title,
    steps,
    step,
    setStep,
    isOpenConfirmModal,
    setIsOpenConfirmModal,
  };
}
